import {
    formatDuration, getLocaleObj, intervalToDuration, differenceInSeconds,
} from './dates.js';

import {
    pad,
} from '@shared/utils/general.js';

export enum Timer {
    On = 'on',
    Off = 'off'
}

// Human readable countdown timer
export const getRemainingTimeString = (endDate: Date, onFinish: () => any): string => {
    const duration = intervalToDuration({
        end: endDate,
        start: new Date(),
    });

    let remainingTimeString = '-';

    if (duration.months > 0) {
        remainingTimeString = formatDuration(duration, {
            format: ['months'],
            locale: getLocaleObj(),
        });
    } else if (duration.days) {
        remainingTimeString = formatDuration(duration, {
            format: ['days'],
            locale: getLocaleObj(),
        });
    } else if (duration.hours > 0 || duration.minutes > 0 || duration.seconds > 0) {
        remainingTimeString = getDigitalTime(endDate, onFinish);
    } else if (onFinish) {
        onFinish();
    }

    return remainingTimeString;
};

// Digital countdown timer
export const getDigitalTime = (endDate: Date, onFinish: () => any): string => {
    const duration = differenceInSeconds(
        endDate,
        new Date()
    );

    if (!duration) {
        onFinish();
    }

    const hours = Math.floor(duration / 60 / 60);
    const minutes = Math.floor(duration / 60) % 60;
    const seconds = Math.round(duration % 60);

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

export const getIntervalDuration = (duration) => {
    if (duration.years || duration.months || duration.days) {
        return 1000 * 60 * 60;
    }

    return 1000;
};